import { render, staticRenderFns } from "./CountriesTable.html?vue&type=template&id=27dbfa20&scoped=true&"
import script from "./CountriesTable.js?vue&type=script&lang=js&"
export * from "./CountriesTable.js?vue&type=script&lang=js&"
import style0 from "./CountriesTable.css?vue&type=style&index=0&id=27dbfa20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dbfa20",
  null
  
)

export default component.exports